export default __webpack_public_path__ + "static/media/mail.5a950130.svg";